<template>
	<div v-show="show">
		<vs-row v-if="OptimizationGroupCreatePermission">
			<div class="vx-col w-full mb-base">
				<OptimizationGroupForm
					:data="groupItem"
					:isEditActive="false"
					@showSidebar="showSidebarEmit"
					@refreshList="$emit('refreshList')"
				/>
			</div>
		</vs-row>
		<not-permission v-else></not-permission>
	</div>
</template>
<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import OptimizationGroupForm from "../OptimizationGroupForm.vue";

export default {
	name: "OptimizationGroupCreate",
	components: {
		NotPermission,
		OptimizationGroupForm,
	},
	data() {
		return {
			groupItem: {},
			show: false,
		};
	},
	computed: {
		OptimizationGroupCreatePermission() {
			return this.$store.getters.checkPermission("OPTIMIZATION_GROUP_C");
		},
	},
	methods: {
		showSidebarEmit(val) {
			this.$emit("showSidebar", val);
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
